import ApiWrapper from "./ApiWrapper";

var FundamentalsService = {
    getBasics({ stockId }) {
        return ApiWrapper.post('/api/Fundamental/getBasics', { stockId });
    }
}

export default FundamentalsService
